<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editCategory="selected"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :access="checkRightStatus(8)" title="Category" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="categorys"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">
              <v-avatar tile class="mt-2 mb-2 mr-2">
                <v-img v-if="item.imageUrl" :src="item.imageUrl"> </v-img>
              </v-avatar>
            </td>
            <td class="text-center">
              {{ item.localId }}
            </td>
            <td class="text-left">
              {{ item.name }}
            </td>
            <td class="text-left">
              {{ item.note }}
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(24)"
                    @click="editCategory(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(8)"
                    @click="deleteCategory(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import categroyService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "category-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selected: null,
      expanded: [],
      headers: [
      {
          text: "",
          align: "left",
          width: '10%',
        },
        {
          text: this.$t("labels.id"),
          align: "center",
          value: "localId",
          sortable: true,
        },
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("labels.description"),
          align: "left",
          value: "note",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      categorys: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Category";
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      return categroyService.getAll().then((response) => {
        this.loading = false;
        console.log("categorys", response);
        this.categorys = response.data;
        return response;
      });
    },
    editCategory(category) {
      this.selected = category;
      this.editDialog = !this.editDialog;
    },
    deleteCategory(category) {
      if (category.productCount > 0) {
        this.$swal({
          title: "Delete Category",
          text: `${category.name} is used in ${category.productCount} product(s) change from product before you delete this category`,
          icon: "warning",
        });
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            categroyService.delete(category.id).then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Category has been deleted.", "success");
                this.getList();
              }
            });
          }
        });
      }
    },
  },
};
</script>
